import React from 'react';
import TreatmentsTemplate from '../treatmentsTemplate/TreatmentsTemplate';

const pageTitle = 'HA Injection';
const pageSubTitle = 'How do HA injections work?';
const pageDescription = 'Hyaluronic acid injections may help to lubricate the knee and provide pain relief and increased mobility. This injection may be an option for patients who have not benefited from standard treatments such as anti-inflammatory medications, physical therapy and cortisone injections. This injection does not work for all patients and it is important to discuss this option with your medical provider.';
const videoKey = 'ebRmwSTGcng';

const resourceLinks = [
    {
        title: 'Arthritis: Shots for Knee Pain',
        link: 'https://healthy.kaiserpermanente.org/health-wellness/health-encyclopedia/he.arthritis-shots-for-knee-pain.abq4711',
    },
    {
        title: 'Knee Arthritis: Treatments',
        link: 'https://healthy.kaiserpermanente.org/health-wellness/health-encyclopedia/he.knee-arthritis-treatments.abq5105',
    },
    {
        title: 'Hyaluronic Acid Injections for Osteoarthritis',
        link: 'https://www.arthritis.org/health-wellness/treatment/treatment-plan/disease-management/hyaluronic-acid-injections-for-knee-pain',
    },
    {
        title: 'Hyaluronic Acid Injections for Osteoarthritis',
        link: 'https://www.webmd.com/osteoarthritis/hyaluronic-acid-injections-for-osteoarthritis',
    },
];

const HAInjection = () => {
    return (
        <TreatmentsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={pageDescription}
            videoKey={videoKey}
            resourceLinks={resourceLinks}
            pageType="treatment"
        />
    );
};

export default HAInjection;